<template>
    <div class="content content--registration">
        <div class="small-window">
            <div class="form-wrap">
                <h1 class="form-wrap__title form-wrap__title--sticky">Адрес регистрации</h1>

                <div class="form-wrap__row">
                    <c-radio-group v-model="registrationState" :valueList="registrationStateList" :label="stateLabel"
                                   :fieldName="'state'"
                                   v-on:change="getDistrict(registrationState, 'registrationDistrictList')"></c-radio-group>
                </div>


                <div class="form-wrap__row" v-if="registrationDistrictListShow">
                    <c-radio-group v-model="registrationDistrict" :valueList="registrationDistrictList"
                                   :label="districtLabel" :fieldName="'district'"
                                   v-on:change="getCity(registrationDistrict, 'registrationCityList')"></c-radio-group>
                </div>

                <div class="form-wrap__row" v-if="registrationCityListShow">
                    <c-radio-group v-model="registrationCity" :valueList="registrationCityList" :label="cityLabel"
                                   :fieldName="'city'" v-on:change="selectCity('registration')"></c-radio-group>
                </div>

                <div class="form-wrap__row" v-if="registrationRegionLast">
                    <c-input
                            :label="'Улица'"
                            :type="'text'"
                            :fieldName="'registrationStreet'"
                            :validation="'alphaKazNum'"
                            
                            :externalStatus="registrationStreetExternalStatus"
                            v-model="registrationStreet"
                    >
                        <template slot="hint"></template>
                        <template slot="tooltip"></template>
                    </c-input>
                </div>
                <div class="form-wrap__row" v-if="registrationRegionLast">
                    <c-input
                            :label="'Дом'"
                            :type="'text'"
                            :fieldName="'registrationHouse'"
                            :validation="'alpha_num'"
                            :externalStatus="registrationHouseExternalStatus"
                            v-model="registrationHouse"
                    >
                        <template slot="hint"></template>
                        <template slot="tooltip"></template>
                    </c-input>
                </div>
                <div class="form-wrap__row" v-if="registrationRegionLast">
                    <c-input
                            :label="'Квартира'"
                            :type="'text'"
                            :fieldName="'registrationApartment'"
                            :validation="'alpha_num'"
                            :externalStatus="registrationApartmentExternalStatus"
                            v-model="registrationApartment"
                    >
                        <template slot="hint"></template>
                        <template slot="tooltip"></template>
                    </c-input>
                </div>
                <div class="form-wrap__row" v-if="registrationRegionLast">
                    <c-input
                            :label="'Номер телефона'"
                            :type="'tel'"
                            :fieldName="'registrationHomePhone'"
                            :validation="'decimal'"
                            :mask="'+7(###)###-##-##'"
                            :externalStatus="registrationHomePhoneExternalStatus"
                            v-model="registrationHomePhone"
                    >
                        <template slot="hint"></template>
                        <template slot="tooltip"></template>
                    </c-input>
                </div>
                <div class="form-wrap__row" v-if="registrationInfoBlockFilled && !isCompleteBlock('residenceInfo')">
                    <div class="form-button__wrap">
                        <button class="form-button form-button--violet"
                                v-on:click="save(['residenceRegion', 'residenceDistrict', 'residenceCity', 'residenceInfo'])">
                            Продолжить
                        </button>
                    </div>
                </div>


                <div class="form-wrap__row" v-if="isCompleteBlock('residenceInfo')">
                    <c-radio-group v-model="liveWhereRegistred" :valueList="liveWhereRegistredList"
                                   :label="liveWhereRegistredLabel"
                                   :fieldName="'liveWhereRegistred'"
                                   v-on:change="whereRegistredSelect"></c-radio-group>
                </div>


                <h1 class="form-wrap__title" v-if="liveWhereRegistredMark">Адрес проживания</h1>


                <div class="form-wrap__row" v-if="liveWhereRegistredMark">
                    <c-radio-group v-model="homeState" :valueList="homeStateList" :label="stateLabel"
                                   :fieldName="'homeState'"
                                   v-on:change="getDistrict(homeState, 'homeDistrictList')"></c-radio-group>
                </div>


                <div class="form-wrap__row" v-if="homeDistrictListShow">
                    <c-radio-group v-model="homeDistrict" :valueList="homeDistrictList"
                                   :label="districtLabel" :fieldName="'homeDistrict'"
                                   v-on:change="getCity(homeDistrict, 'homeCityList')"></c-radio-group>
                </div>

                <div class="form-wrap__row" v-if="homeCityListShow">
                    <c-radio-group v-model="homeCity" :valueList="homeCityList" :label="cityLabel"
                                   :fieldName="'homeCity'" v-on:change="selectCity('home')"></c-radio-group>
                </div>


                <div class="form-wrap__row" v-if="homeRegionLast">
                    <c-input
                            :label="'Улица'"
                            :type="'text'"
                            :fieldName="'homeStreet'"
                            :validation="'alphaKazNum'"
                            
                            :externalStatus="homeStreetExternalStatus"
                            v-model="homeStreet"
                    >
                        <template slot="hint"></template>
                        <template slot="tooltip"></template>
                    </c-input>
                </div>
                <div class="form-wrap__row" v-if="homeRegionLast">
                    <c-input
                            :label="'Дом'"
                            :type="'text'"
                            :fieldName="'homeHouse'"
                            :validation="'alpha_num'"
                            
                            :externalStatus="homeHouseExternalStatus"
                            v-model="homeHouse"
                    >
                        <template slot="hint"></template>
                        <template slot="tooltip"></template>
                    </c-input>
                </div>
                <div class="form-wrap__row" v-if="homeRegionLast">
                    <c-input
                            :label="'Квартира'"
                            :type="'text'"
                            :fieldName="'homeApartment'"
                            :validation="'alpha_num'"
                            
                            :externalStatus="homeApartmentExternalStatus"
                            v-model="homeApartment"
                    >
                        <template slot="hint"></template>
                        <template slot="tooltip"></template>
                    </c-input>
                </div>

                <div class="form-wrap__row" v-if="homeInfoBlockFilled">
                    <div class="form-button__wrap">
                        <router-link :to="{name: 'Employment'}"
                                     @click.native="save(['residenceRegion', 'residenceDistrict', 'residenceCity', 'residenceInfo','homeRegion', 'homeDistrict', 'homeCity', 'homeInfo'])"
                                     tag="button" class="form-button form-button--yellow form-button--long-text">Продолжить
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
    import {createHelpers} from 'vuex-map-fields';
    import store from '@/storage/index'
    import each from 'lodash/each'
    import sortBy from 'lodash/sortBy'
    import {GET_PROFILE} from "@/storage/mutations";
    import {TOGGLE_LOADER} from "@/storage/mutations";
    import {STATUSES} from "@/components/statuses";
    import registrationMixins from '@/modules/mixins/registrationMixins'

    const {mapFields} = createHelpers({
        getterType: 'profile/getField',
        mutationType: 'profile/updateField',
    });


    export default {
        mixins: [registrationMixins],
        name: 'Address',
        metaInfo: {
            title: 'Регистрация'
        },
        data() {
            return {
                registrationStateList: [],

                registrationDistrictList: [],
                registrationDistrictListShow: false,

                registrationCityList: [],
                registrationCityListShow: false,

                registrationRegionLast: false,

                homeStateList: [],

                homeDistrictList: [],
                homeDistrictListShow: false,

                homeCityList: [],
                homeCityListShow: false,

                homeRegionLast: false,
            }
        },
        watch: {
            registrationState: function (newVal, oldVal) {
                if (newVal) {

                }
            },
            registrationDistrict: function (newVal, oldVal) {
                if (newVal) {
                }
            },
            homeState: function (newVal, oldVal) {
                if (newVal) {
                }
            },
            homeDistrict: function (newVal, oldVal) {
                if (newVal) {
                }
            },
        },
        methods: {
            
            getProvince: function (listName) {
                let _this = this;
                this[listName] = [];
                this.$http.get('/json/addresses/province-cities').then(
                    response => {
                        let list = sortBy(response.data.data, ['id']);
                        each(list, function (item, key) {
                            _this[listName].push({label: item.name, value: item.id});
                        })
                    },
                    response => {
                        //TODO: Логирование ошибок
                    }
                )
            },

            getDistrict: function (parentId, district) {
                let _this = this;
                _this[district] = [];
                this.$http.get('/json/addresses/district-towns?parentId=' + parentId).then(
                    response => {
                        if (response.data.data.length > 0) {
                            let list = sortBy(response.data.data, ['id']);
                            each(list, function (item, key) {
                                _this[district].push({label: item.name, value: item.id});
                            });
                            _this[district + 'Show'] = true;

                            if (district === 'registrationDistrictList') {
                                _this.registrationRegionLast = false;
                                _this.save(['residenceRegion']);
                            } else {
                                _this.homeRegionLast = false;
                                _this.save(['homeRegion']);
                            }
                        } else {
                            if (district === 'registrationDistrictList') {
                                _this.registrationRegionLast = true;
                                _this.save(['residenceRegion']);
                            } else {
                                _this.homeRegionLast = true;
                                _this.save(['homeRegion']);
                            }
                        }
                    },
                    response => {
                        //TODO: Логирование ошибок
                    }
                );
            },
            getCity: function (parentId, city) {
                let _this = this;
                _this[city] = [];
                this.$http.get('/json/addresses/city-villages?parentId=' + parentId).then(
                    response => {
                        if (response.data.data.length > 0) {
                            let list = sortBy(response.data.data, ['id']);
                            each(list, function (item, key) {
                                _this[city].push({label: item.name, value: item.id});
                            });
                            _this[city + 'Show'] = true;
                            if (city === 'registrationCityList') {
                                _this.registrationRegionLast = false;
                                _this.save(['residenceRegion', 'residenceDistrict']);
                            } else {
                                _this.homeRegionLast = false;
                                _this.save(['homeRegion', 'homeDistrict']);
                            }
                        } else {
                            if (city === 'registrationCityList') {
                                _this.registrationRegionLast = true;
                                _this.save(['residenceRegion', 'residenceDistrict']);
                            } else {

                                _this.homeRegionLast = true;
                                _this.save(['homeRegion', 'homeDistrict']);
                            }
                        }
                    },
                    response => {
                        //TODO: Логирование ошибок
                    }
                );
            },
            selectCity: function (addressType) {
                if (addressType === 'registration') {
                    this.registrationRegionLast = true;
                    this.save(['residenceRegion', 'residenceDistrict', 'residenceCity']);
                } else {
                    this.homeRegionLast = true;
                    this.save(['homeRegion', 'homeDistrict', 'homeCity']);
                }
            },
            whereRegistredSelect: function () {
                if (this.liveWhereRegistred) {
                    this.homeStateList = this.registrationStateList;
                    this.homeDistrictList = this.registrationDistrictList;
                    this.homeCityList = this.registrationCityList;

                    this.homeState = this.registrationState;
                    this.homeDistrict = this.registrationDistrict;
                    this.homeCity = this.registrationCity;
                    this.homeStreet = this.registrationStreet;
                    this.homeHouse = this.registrationHouse;
                    this.homeApartment = this.registrationApartment;
                    this.save(['residenceRegion', 'residenceDistrict', 'residenceCity', 'residenceInfo', 'homeRegion', 'homeDistrict', 'homeCity', 'homeInfo'])
                    this.$router.push({name: 'Employment'})
                } else {

                }
            }
        },
        asyncComputed: {},
        computed: {
            stateLabel: function () {
                return this.registrationState > 0 ? 'Область' : 'Область / Город';
            },
            districtLabel: function () {
                return this.registrationDistrict > 0 ? 'Район' : 'Район / Населенный пункт';
            },
            cityLabel: function () {
                return this.registrationCity > 0 ? 'Город / Село' : 'Город / Село';
            },
            liveWhereRegistredLabel: function () {
                return this.liveWhereRegistred === '' ? 'Проживаете по адресу регистрации?' : 'Регистрация';
            },
            liveWhereRegistredList: function () {
                if (this.liveWhereRegistred === '') {
                    return [
                        {
                            label: 'Да',
                            value: true
                        },
                        {
                            label: 'Нет',
                            value: false
                        }
                    ]
                } else {
                    return [
                        {
                            label: 'По адресу проживания',
                            value: true
                        },
                        {
                            label: 'По другому адресу',
                            value: false
                        }
                    ]
                }
            },
            liveWhereRegistredMark: function () {
                return (this.liveWhereRegistred !== '') && !this.liveWhereRegistred;
            },
            registrationInfoBlockFilled: function () {
                return this.registrationStreet !== '' &&
                    this.registrationHouse !== '' &&
                    this.registrationHomePhone !== '';
            },
            homeInfoBlockFilled: function () {
                return this.homeStreet !== '' &&
                    this.homeHouse !== '';
            },

            ...mapFields([
                'liveWhereRegistred',
                'registrationState',
                'registrationStateExternalStatus',


                'registrationDistrict',
                'registrationDistrictExternalStatus',


                'registrationCity',
                'registrationCityExternalStatus',



                'registrationStreet',
                'registrationStreetExternalStatus',


                'registrationHouse',
                'registrationHouseExternalStatus',


                'registrationApartment',
                'registrationApartmentExternalStatus',


                'registrationHomePhone',
                'registrationHomePhoneExternalStatus',



                'homeState',
                'homeStateExternalStatus',


                'homeDistrict',
                'homeDistrictExternalStatus',


                'homeCity',
                'homeCityExternalStatus',



                'homeStreet',
                'homeStreetExternalStatus',


                'homeHouse',
                'homeHouseExternalStatus',


                'homeApartment',
                'homeApartmentExternalStatus',


                'homeHomePhone',
                'homeHomePhoneExternalStatus',

            ]),
        },
        mounted() {
            this.getProvince('registrationStateList');
            this.getProvince('homeStateList');
            this.$store.commit('CHANGE_PROGRESS', {progressBarShow: true, currentPercent: 30, nextPercent: 20});
        }
    }
</script>

<style lang="scss">

</style>